import { Component, OnInit, Pipe } from '@angular/core';
import { GLOBAL } from 'src/app/services/global';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-aux-cert-sin-p',
  templateUrl: './aux-cert-sin-p.component.html',
  styleUrls: ['./aux-cert-sin-p.component.css']
})



export class AuxCertSinPComponent {
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;



  public dataSource = [
    // { tipo: "Fotocopia Oficio Planos, PE, RE, etc.", valor: "$50" },
    // { tipo: "Copia de plano (tamaño original).", valor: "0.2 ML" },
    // { tipo: "Desarchivo Expediente.", valor: "2.5% UTM" },
    // { tipo: "Autentificación Secretario Municipal.", valor: "2% UTM" }
  ]





  displayedColumns: string[] = ['tipo', 'valor'];
  valor_UTM;
  valor_Corvi;


  constructor(
    private dialog: MatDialog,
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _userService: UserService
  ) {
    console.log("aux-cert-sin-p constructor")
    this.spinner.show();
    this._userService.valoresTramites().subscribe(
      response => {
        this.spinner.hide();
        console.log("valoresTramites response", response);
        this.dataSource = response.valores
        this.valor_UTM = response.utm;
        this.valor_Corvi = response.corvi;


      });

    //cargar valores tabla


  }
  ngOnInit() {
    //this.spinner.hide()



  }

  cerrar_vista() {
    this._router.navigate([`/inicio`]);
  }

  sign(tipo) {
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'resoluciones') {
        // console.log("expediente 1");
        localStorage.setItem("vista_vivienda", "resoluciones")

        this._router.navigate([`/solicitud_vivienda/resoluciones`]);
      }
      if (tipo == 'copia_documentos') {
        // console.log("expediente 1");
        localStorage.setItem("vista_vivienda", "copia_documentos")

        this._router.navigate([`/solicitud_vivienda/copia_documentos`]);
      }
      if (tipo == 'constancia') {
        // console.log("expediente 1");
        this._router.navigate([`/constancia`]);
      }

    } else {
      this.dialog.closeAll();
      if (tipo == 'resoluciones') {
        // console.log("expediente 1");
        localStorage.setItem("vista_vivienda", "resoluciones")

        this._router.navigate([`/solicitud_vivienda/resoluciones`]);
      }
      if (tipo == 'copia_documentos') {
        // console.log("expediente 1");
        localStorage.setItem("vista_vivienda", "copia_documentos")

        this._router.navigate([`/solicitud_vivienda/copia_documentos`]);
      }
      if (tipo == 'constancia') {
        // console.log("expediente 1");
        this._router.navigate([`/constancia`]);
      }
    }
  }
}
